export class TimeoutError extends Error {
    public statusCode: number;
    public errorCode?: string;
    public innerError?: Error | string;

    constructor(code = 401, errorCode = 'Timeout', innerError?: Error | string) {
        super(`${code} ${errorCode} ${innerError}`);
        this.name = 'TimeoutError';
    }
}
